import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const ItemsField = ({ record, source, alwaysList = false }) => {
	const translate = useTranslate();
	const items = get(record, source, []);
	// Piccola pezzottata per forzare, in questa schermata,
	// la visualizzazione dell'evento REV (Revenue Network) con simbolo %.
	// NB: Nella tabella stats si deve vedere in €
	const getSign = () => {
		return get(record, "event.code") === "REV"
			? "%"
			: get(record, "event.sign", "€");
	};
	if (items.length === 1 && !alwaysList) {
		return (
			<Typography variant="body2">
				{translate("resources.bookmaker-deals.fields.one_item", {
					amount: items[0].amount,
					sign: getSign(),
					event: translate(
						`resources.events.code.${get(record, "event.name")}`
					),
				})}
			</Typography>
		);
	} else {
		return (
			<>
				{items.map((item, index) => (
					<Typography key={index} variant="body2">
						{translate("resources.bookmaker-deals.fields.multi_item", {
							amount: item.amount,
							event:
								index < items.length - 1
									? translate(
											`resources.events.code.${get(record, "event.name")}`
									  )
									: "",
							sign: getSign(),
							value_limit:
								index < items.length - 1
									? item.value_limit
									: translate(
											"resources.bookmaker-deals.fields.multi_item.infinite"
									  ),
						})}
					</Typography>
				))}
			</>
		);
	}
};
export default ItemsField;
